import { useDeliveryFlowStore } from "../../../store/newVehicleDeliveryStore";
import { CheckCircleIcon, DotCalendarIcon, EmailIcon, LeftArrow, MapPinIcon, PhoneIcon } from "../../../icons";
import { Button } from "../../../components/ui/Button";
import { useNavigate } from "react-router-dom";
import { AlertBanner } from "../../../components/ui/AlertBanner";

export const BookingAuthorized = () => {

  // GLOBAL STATE: 
  const carData = useDeliveryFlowStore((s) => s.carData);
  
  const deliveryInfo = useDeliveryFlowStore(
    (s) => s.deliveryStatusByPlate[carData?.vehPlate ?? carData?.plateno]
  );

  const availableDate = new Date(deliveryInfo?.availableFrom).toISOString().split("T")[0] ?? null

  // LOCAL STATE:
  const navigate = useNavigate();

  // FETCH DATA:
 
  // LOCAL VARIABLES:

  // USE EFFECTS:

  // HANDLERS & FUNCTIONS:

  return (
    <div className=''>
      <div className="flex flex-row gap-2 justify-start items-start w-full pb-4 mb-10 border-b-[0.5px] border-fadedgrey lg:mr-[45px] h-min">
        <Button className='h-full pl-1' onClick={()=>{navigate(-1)}}><LeftArrow className='cursor-pointer stroke-black'/></Button>
        <DotCalendarIcon className="stroke-black w-[18px] h-[18px]"/>
        <h4 className='font-bold'>Κλείσε το ραντεβού σου</h4>
      </div>

      <div className='flex flex-col gap-6'>
        <h4>Επικοινώνησε εντός 3 εργάσιμων ημερών με το Τμήμα Παράδοσης Αυτοκινήτων για να προγραμματίσεις ραντεβού παραλαβής:</h4>
        <div className={`"shadow-md rounded-xl py-6 px-10 bg-white flex flex-col gap-2`}>
          <p className='text-sm font-bold'>Τμήμα Παράδοσης Αυτοκινήτων Avis</p>
          <div className='flex flex-row gap-1'>
            <EmailIcon className='w-4 h-4' />
            <p className='text-sm'>car-delivery@avis.gr</p>
          </div>
          <div className='flex flex-row gap-1'>
            <PhoneIcon className='w-5 h-5' />
            <p className='text-sm'>(+30)2106879909</p>
          </div>
          <div className='flex flex-row gap-1'>
            <DotCalendarIcon className='w-5 h-5' />
            <p className='text-sm'>Διαθέσιμο για παραλαβή από {(() => {
                const [y, m, d] = availableDate.split("-");
                return `${d}.${m}.${y}`;
              })()}</p>
          </div>
        </div>
        <div className={`"shadow-md rounded-xl py-6 px-10 bg-white flex flex-col gap-2`}>
          <p className='text-sm font-bold'>Διεύθυνση παραλαβής</p>
          <div className='flex flex-row gap-1'>
            <MapPinIcon className='w-4 h-4' />
            <p className='text-sm'>{deliveryInfo?.deliveryLocation?.address}, {deliveryInfo?.deliveryLocation?.city}, {deliveryInfo?.deliveryLocation?.province}</p>
          </div>
          {/* {deliveryInfo?.deliveryLocation?.phones?.length > 0 && <div className='flex flex-row gap-1'>
            <PhoneIcon className='w-4 h-4' />
            <p className='text-sm'>{deliveryInfo?.deliveryLocation?.phones?.[0]}</p>
          </div>} */}
        </div>
        <AlertBanner severity="info" className='pb-1'>
          <div className='flex flex-row gap-[14px] justify-start align-top p-3'>
              <CheckCircleIcon width='20' height='20' className={'stroke-[#2E9BFF] shrink-0'} />
              <p className='text-sm'>Η τιμολόγηση θα ξεκινήσει εντός 3 εργάσιμων ημερών από την ημερομηνία διαθεσιμότητας του αυτοκινήτου για παραλαβή.</p>
          </div>
      </AlertBanner>
      </div>
    </div>
  );
};
